import { Component } from '@angular/core';

@Component({
  selector: 'app-impressum',
  imports: [],
  templateUrl: './impressum.component.html',
  styleUrl: './impressum.component.sass'
})
export class ImpressumComponent {

}
